import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  currentLang: `${localStorage.getItem('lang') || 'fr'}`,
};

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    updateCurrentLang: (state: { currentLang: string }, action) => ({ currentLang: action.payload }),
  },
});

export const languageActions = languageSlice.actions;

export default languageSlice.reducer;
